export default __webpack_public_path__ + "static/media/immigration.4fdf4acd.png";